export function isRoomSceneType(sceneType) {
    if (!sceneType) {
        return false;
    }
    return sceneType === 'lobby' || sceneType === 'poker' || sceneType === 'mttStaging';
}
